"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EContentModeType = exports.EContentPanelRoute = void 0;
var EContentPanelRoute;
(function (EContentPanelRoute) {
  /** главный раздел */
  EContentPanelRoute["main"] = "main";
  /** библиотека */
  EContentPanelRoute["lessons"] = "lessons";
  /** обучение */
  EContentPanelRoute["classes"] = "classes";
  /** преподаватели */
  EContentPanelRoute["tutors"] = "tutors";
  /** раздел /news */
  EContentPanelRoute["news"] = "news";
  /** Школы */
  EContentPanelRoute["schools-and-groups"] = "schools-and-groups";
  /**
   * @deprecated Заглушка для формировани отдельной страницы вебинаров
   */
  EContentPanelRoute["webinars"] = "webinars";
  /**
   * @deprecated Заглушка для формировани отдельной страницы страницы
   */
  EContentPanelRoute["streams"] = "streams";
  /**
   * @deprecated Заглушка для формировани отдельной страницы групповых занятий
   */
  EContentPanelRoute["group-lessons"] = "group-lessons";
  /**
   * @deprecated Заглушка для формировани отдельной страницы индивидуальных занятий
   */
  EContentPanelRoute["individual-lessons"] = "individual-lessons";
  /** коллекции уроков */
  EContentPanelRoute["collections"] = "collections";
  /** Школы */
  EContentPanelRoute["schools"] = "schools";
  /** Классные комнаты */
  EContentPanelRoute["classrooms"] = "classrooms";
  /** Мои занятия */
  EContentPanelRoute["my-classes"] = "my-classes";
  EContentPanelRoute["my-classes/dashboard"] = "my-classes/dashboard";
  EContentPanelRoute["my-classes/events"] = "my-classes/events";
  EContentPanelRoute["my-classes/tutors"] = "my-classes/tutors";
  EContentPanelRoute["my-classes/classrooms"] = "my-classes/classrooms";
  EContentPanelRoute["my-classes/homework"] = "my-classes/homework";
  EContentPanelRoute["my-classes/students"] = "my-classes/students";
  EContentPanelRoute["my-classes/schools"] = "my-classes/schools";
  /** Моя библиотека */
  EContentPanelRoute["my-library"] = "my-library";
  EContentPanelRoute["my-library/lessons"] = "my-library/lessons";
  EContentPanelRoute["my-library/services"] = "my-library/services";
  EContentPanelRoute["my-library/courses"] = "my-library/courses";
  EContentPanelRoute["my-library/collections"] = "my-library/collections";
  EContentPanelRoute["my-library/activity"] = "my-library/activity";
  /** Страница комментариев авторов на которых я подписан */
  EContentPanelRoute["comments"] = "comments";
  /** Страница все мои коментарии */
  EContentPanelRoute["people-news"] = "people-news";
  EContentPanelRoute["school-news"] = "school-news";
  EContentPanelRoute["classroom-news"] = "classroom-news";
  /** Страница избранное */
  EContentPanelRoute["favorites"] = "favorites";
  EContentPanelRoute["favorites/lessons"] = "favorites/lessons";
  EContentPanelRoute["favorites/services"] = "favorites/services";
  EContentPanelRoute["favorites/tutors"] = "favorites/tutors";
  EContentPanelRoute["favorites/collections"] = "favorites/collections";
  EContentPanelRoute["favorites/users"] = "favorites/users";
  EContentPanelRoute["favorites/schools"] = "favorites/schools";
})(EContentPanelRoute = exports.EContentPanelRoute || (exports.EContentPanelRoute = {}));
var EContentModeType;
(function (EContentModeType) {
  /** все (обычный режим) */
  EContentModeType["all"] = "all";
  /** созданы мной */
  EContentModeType["my"] = "my";
  /** добавлены в избранное мной */
  EContentModeType["favorites"] = "favorites";
  /** недавно созданные */
  EContentModeType["last-added"] = "last-added";
  /** недавно просмотренные мной */
  EContentModeType["last-viewed"] = "last-viewed";
  /** популярные */
  EContentModeType["popular"] = "popular";
  /** поиск */
  EContentModeType["search"] = "search";
  /** не найдено */
  EContentModeType["not-found"] = "not-found";
  /** Боковые виджеты */
  EContentModeType["sidebar-widgets"] = "sidebar-widgets";
})(EContentModeType = exports.EContentModeType || (exports.EContentModeType = {}));
